import React,{useState,useEffect} from 'react';
import axios from "./axios";
import requests from "./request"
import "./banner.css"

function Banner() {
 const[movies,setMovies]=useState({});

 useEffect(() => {        {/** runs on a specific condition */}
  async function fetchData(){
      const request= await axios.get(requests.fetchNetflixOriginals);
      //Math.floor(Math.random()*request.data.results.length-1)
    //  console.log(request.data.result[Math.floor(Math.random()*request.data.results.length-1)])
      setMovies(
          request.data.results[
              Math.floor(Math.random()*request.data.results.length-1)])   
              
   return request;
}
   fetchData(); 
     
 }, []);
 console.log(movies)
 function truncate(str,n){
     return str?.length>n?str.substr(0,n-1)+"....":str; 
 }

    return ( 
        <header className="Banner"
        style={{
            backgroundSize:"cover",
            backgroundImage:`url("https://image.tmdb.org/t/p/original/${movies?.backdrop_path}")`,
 
        }}
        >{/**bg image */}
            <p>@Adarsh Gupta</p>
            <div className="Banner_contents"><div className="Bannertitle">{movies?.title||movies?.name||movies?.orginal_name}</div>

            <div className="Banner_Buttons">
                <button className="Banner_Buttons">Play</button> 
                <button className="Banner_Buttons">ADD TO MY LIST</button>
                
            </div>
            <h1 className="Banner-descriptions">
                {truncate(movies?.overview,250)}
            </h1>
            </div>
            <div className="fade">

            </div>

            {/* title
                             2 buttons ==play and add to list
            description */}
        </header>
    )
}

export default Banner
